const { default: Home } = require('@/components/svgs/sider/Home')
const { default: Profile } = require('../components/svgs/sider/Profile')
const { default: ProfileA } = require('../components/svgs/sider/ProfileA')
const { default: Services } = require('@/components/svgs/sider/Services')
const { default: ServicesA } = require('@/components/svgs/sider/ServicesA')
const { default: ContactUs } = require('@/components/svgs/sider/ContactUs')
const { default: Requests } = require('@/components/svgs/sider/Requests')
const { default: RequestsA } = require('@/components/svgs/sider/RequestsA')
const { default: Payments } = require('../components/svgs/sider/Payments')
const { default: PaymentsA } = require('../components/svgs/sider/PaymentsA')
const { default: FollowUp } = require('@/components/svgs/sider/FollowUp')
const { default: FollowUpA } = require('@/components/svgs/sider/FollowUpA')
const { default: Blog } = require('@/components/svgs/sider/Blog')
const { default: Location } = require('@/components/svgs/sider/Location')
const { default: Subscriptions } = require('../components/svgs/sider/Subscriptions')
const { publicSubscriptionRoutes } = require('@/utils/subscriptionRoutes')
const { getPublicPackageRoute } = require('@/utils/packageRoutes')

export const renderHomeTree = (isAuth) => {
  return [
    {
      key: 'home',
      path: '',
      title: 'Home',
      icon: <Home color='#FFF' />,
      iconActive: <Home />,
    },
    {
      key: 'profile',
      path: '/dashboard/profile',
      title: 'profile.title',
      icon: <Profile />,
      iconActive: <ProfileA />,
      auth: true,
    },
    {
      key: 'services',
      path: isAuth ? '/dashboard/servizi' : '/servizi',
      title: 'homenav.Services',
      icon: <Services />,
      iconActive: <ServicesA />,
    },
    ...(!isAuth
      ? [
          {
            key: 'subscriptions-public',
            path: publicSubscriptionRoutes.promo,
            title: 'Abbonamenti',
            icon: <Subscriptions />,
            iconActive: <Subscriptions isActive={true} />,
            submenu: [
              {
                key: 'subscription-annuale',
                path: publicSubscriptionRoutes.promo,
                title: 'CAF e Patronato',
              },
              {
                key: 'subscription-colf-badanti',
                path: getPublicPackageRoute('colf-e-badanti'),
                title: 'Colf e Badanti',
              },
              {
                key: 'subscription-smart-forfettario',
                path: getPublicPackageRoute('smart-forfettario'),
                title: 'Smart Forfettario',
              },
            ],
          },
        ]
      : []),
    {
      key: 'requests',
      path: '/dashboard/requests',
      title: 'sidenav.Requests',
      icon: <Requests />,
      iconActive: <RequestsA />,
      auth: true,
    },
    {
      key: 'my-subscriptions',
      path: '/dashboard/my-subscriptions',
      title: 'sidenav.Subscriptions',
      icon: <Subscriptions />,
      iconActive: <Subscriptions isActive={true} />,
      auth: true,
    },
    {
      key: 'Payments',
      path: '/dashboard/payments',
      title: 'sidenav.Payments',
      icon: <Payments />,
      iconActive: <PaymentsA />,
      auth: true,
    },
    {
      key: 'followUp',
      path: '/dashboard/tickets',
      title: 'Follow up Inquiries',
      icon: <FollowUp />,
      iconActive: <FollowUpA />,
      auth: true,
    },
    {
      key: 'ContactUs',
      path: '/contact-us',
      title: 'homenav.ContactUs',
      icon: <ContactUs color='#FFF' />,
      iconActive: <ContactUs />,
    },
    {
      key: 'blog',
      path: '/blog',
      title: 'Blog',
      icon: <Blog color='#FFF' />,
      iconActive: <Blog />,
    },
    {
      key: 'branches',
      path: '/branches',
      title: 'homenav.Branches',
      icon: <Location color='#FFF' />,
      iconActive: <Location />,
    },
  ]
}
